import { routes } from "routes/path"

const breadcrumbs = {
  [routes.dashboard]: {
    title: "Dashboard",
    breadcrumbItem: "Dashboard",
  },
  [routes.userCreate]: {
    parent: "Users",
    breadcrumbItem: "Create User",
    parentLink: routes.userList,
  },
  [routes.userUpdate]: {
    parent: "Users",
    breadcrumbItem: "Update User",
    parentLink: routes.userList,
  },
  [routes.userList]: {
    title: "Users",
    breadcrumbItem: "Users",
    link: routes.userList,
  },
  [routes.inquiries]: {
    title: "Inquiries",
    breadcrumbItem: "Inquiries",
  },
  [routes.tutorial]: {
    title: "Tutorial",
    breadcrumbItem: "Tutorial",
  },
  [routes.tutorialForVendor]: {
    title: "Tutorials",
    breadcrumbItem: "Tutorials",
  },
  [routes.plan]: {
    title: "Plans",
    breadcrumbItem: "Plans",
  },
  [routes.feedback]: {
    title: "Feedback",
    breadcrumbItem: "Feedback",
  },
  [routes.finance]: {
    title: "Finance",
    breadcrumbItem: "Finance",
  },
  [routes.setting]: {
    title: "Settings",
    breadcrumbItem: "Settings",
  },
  [routes.subscription]: {
    title: "Subscription",
    breadcrumbItem: "Subscription",
  },
  [routes.categories]: {
    title: "Categories",
    breadcrumbItem: "Categories",
  },
  [routes.reminder]: {
    title: "Reminder",
    breadcrumbItem: "Reminder",
  },
  [routes.accounts]: {
    title: "Accounts",
    breadcrumbItem: "Accounts",
  },
  [routes.items]: {
    title: "Items",
    breadcrumbItem: "Items",
  },
  [routes.size]: {
    title: "Size",
    breadcrumbItem: "Size",
  },
  [routes.color]: {
    title: "Colors",
    breadcrumbItem: "Colors",
  },
  [routes.timeslot]: {
    title: "Time Slots",
    breadcrumbItem: "Time Slots",
  },
  [routes.createProduct]: {
    parent: "Products",
    breadcrumbItem: "Create Product",
    parentLink: routes.productList,
  },
  [routes.updateproduct]: {
    parent: "Products",
    breadcrumbItem: "Update Product",
    parentLink: routes.productList,
  },
  [routes.catalogue]: {
    title: "Stock",
    breadcrumbItem: "Stock",
  },
  // [routes.catalogue]: {
  //   title: "Products Catalogue",
  //   breadcrumbItem: "Products Catalogue",
  // },
  [routes.productList]: {
    title: "Products",
    breadcrumbItem: "Products",
  },
  [routes.productHistory]: {
    title: "Product History",
    breadcrumbItem: "Product History",
  },
  [routes.createbooking]: {
    parent: "Bookings",
    breadcrumbItem: "Create Booking",
    parentLink: routes.bookingList,
  },
  [routes.updatebooking]: {
    parent: "Bookings",
    breadcrumbItem: "Update Booking",
    parentLink: routes.bookingList,
  },
  [routes.bookingList]: {
    title: "Bookings",
    breadcrumbItem: "Bookings",
  },
  [routes.CreditNote]: {
    title: "Credit Notes",
    breadcrumbItem: "Credit Notes",
  },
  [routes.CreateCreditNote]: {
    breadcrumbItem: "Create Credit Notes",
    parent: "Credit Notes",
    parentLink: routes.CreditNote,
  },
  [routes.cartlist]: {
    title: "Cart",
    breadcrumbItem: "Cart",
  },
  [routes.reportBooking]: {
    title: "Bookings",
    breadcrumbItem: "Bookings",
  },
  [routes.delivery]: {
    title: "Deliveries",
    breadcrumbItem: "Deliveries",
  },
  [routes.return]: {
    title: "Returns",
    breadcrumbItem: "Returns",
  },
  [routes.deposit]: {
    title: "Deposit",
    breadcrumbItem: "Deposit",
  },
  [routes.subCategories]: {
    title: "Sub Categories",
    breadcrumbItem: "Sub Categories",
  },
  [routes.pendingBills]: {
    title: "Pending Bills",
    breadcrumbItem: "Pending Bills",
  },
  [routes.salesman]: {
    title: "Salesman",
    breadcrumbItem: "Salesman",
  },
  [routes.bookedOrdersReport]: {
    title: "Booked Order",
    breadcrumbItem: "Booked Order",
  },
  [routes.available]: {
    title: "Generate Bill",
    breadcrumbItem: "Generate Bill",
  },
  [routes.profile]: {
    title: "User Profile",
    breadcrumbItem: "User Profile",
  },
  [routes.HoldBillList]: {
    title: "Hold bills",
    breadcrumbItem: "Hold bills",
  },
  [routes.income]: {
    title: "Income",
    breadcrumbItem: "Income",
  },
  [routes.expenses]: {
    title: "Expenses",
    breadcrumbItem: "Expenses",
  },
  [routes.journalVouchers]: {
    title: "Journal Vouchers",
    breadcrumbItem: "Journal Vouchers",
  },
  [routes.incomeExpense]: {
    title: "Incomes & Expenses",
    breadcrumbItem: "Incomes & Expenses",
  },
  [routes.decrypt]: {
    title: "Decrypt",
    breadcrumbItem: "Decrypt",
  },
  [routes.createSale]: {
    parent: "Sales",
    breadcrumbItem: "Create Sale",
    parentLink: routes.salesList,
  },
  [routes.updateSale]: {
    parent: "Sales",
    breadcrumbItem: "Update Sale",
    parentLink: routes.salesList,
  },
  [routes.salesList]: {
    title: "Sales",
    breadcrumbItem: "Sales",
  },
  [routes.purchaseList]: {
    title: "Purchase",
    breadcrumbItem: "Purchase",
  },
  [routes.createPurchase]: {
    parent: "Purchase",
    breadcrumbItem: "Create purchase",
    parentLink: routes.purchaseList,
  },
  [routes.UpdatePurchase]: {
    parent: "Purchase",
    breadcrumbItem: "Update Purchase",
    parentLink: routes.purchaseList,
  },
  [routes.releseNote]: {
    title: "Relese Note",
    breadcrumbItem: "What's New",
  },
  [routes.InquiryData]: {
    title: "Inquiries",
    breadcrumbItem: "Inquiries",
  },
  [routes.Washing]: {
    title: "Washing",
    breadcrumbItem: "Washing",
  },
  [routes.dbBackup]: {
    title: "Db-Backup",
    breadcrumbItem: "Db-Backup",
  },
  [routes.feedbackQuestion]: {
    title: "Feedback Question",
    breadcrumbItem: "Feedback Question",
  },
  [routes.feedbackReport]: {
    title: "Feedbacks",
    breadcrumbItem: "Feedbacks",
  },
  [routes.manufactureProduct]: {
    title: "Manufacture Product",
    breadcrumbItem: "Manufacture Product",
  },
  [routes.manufactureProduct]: {
    title: "Manufacture Product",
    breadcrumbItem: "Manufacture Product",
  },
  [routes.createmanufactureProduct]: {
    parent: "Manufacture Product",
    title: "Create Manufacture Product",
    breadcrumbItem: "Create Manufacture Product",
    parentLink: routes.manufactureProduct,
  },
  [routes.updatemanufactureProduct]: {
    parent: "Manufacture Product",
    title: "Update Manufacture Product",
    breadcrumbItem: "Update Manufacture Product",
    parentLink: routes.manufactureProduct,
  },
  [routes.bookingOutstanding]: {
    parent: "Bookign Outstanding",
    title: "Bookign Outstanding",
    breadcrumbItem: "Bookign Outstanding",
    // parentLink: routes.manufactureProduct,
  },
}

export default breadcrumbs
